
import { Component, Vue } from 'vue-property-decorator'
import {
  getMerchant,
  delMerchant,
  setMerchant,
  jumpMerchantPlatform
} from '@/api/merchant/merchant'
import pagination from '@/components/Pagination/index.vue'
import addMerchant from './components/merchant/addMerchant.vue'
import basicInformation from './components/merchant/basicInformation.vue'
import productList from './components/product/productList.vue'
import agentProductList from './components/agentProduct/agentProductList.vue'
import fund from './components/fund/fund.vue'
import bankAccountList from './components/bank/bankAccountList.vue'
import depositOrder from './components/order/depositOrder.vue'
import payoutOrder from './components/order/payoutOrder.vue'
import settlementOrder from './components/order/settlementOrder.vue'
import managerList from './components/manager/managerList.vue'
import loginLog from './components/loginLog/loginLog.vue'
import { statusList } from '@/utils/constant'
import { operationMessage } from '@/utils/message'
import { isShowDialog } from '@/utils/permission'
import { reqInterceptors } from '@/utils/interceptors'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'
import batchEdit from './components/batchEdit/index.vue'
import { ClientJS } from 'clientjs'

@Component({
  name: 'merchantList',
  components: {
    pagination,
    addMerchant,
    basicInformation,
    productList,
    agentProductList,
    fund,
    bankAccountList,
    depositOrder,
    payoutOrder,
    settlementOrder,
    managerList,
    loginLog,
    batchEdit
  }
})
export default class extends Vue {
  private form: any = {
    merchant_no: '',
    name: '',
    email: ''
  }

  private merchantList: any[] = []
  private currentMerchant: any = {}
  private statusList = statusList
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private listLoading: boolean = true
  private dialogVisible: boolean = false

  private drawer: boolean = false
  private tabName: string = 'basicInformation'
  private action: string = ''

  /** 设备指纹 */
  private device_fingerprint: any = {}

  get language() {
    return AppModule.language
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.form,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getMerchant(data).then((res: any) => {
        this.total = res.count
        this.merchantList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.form = {
      merchant_no: '',
      name: '',
      email: ''
    }
    this.currentPage = 1
    // this.getMerchantList(false)
    this.hadleGetFilesListApi()
  }

  private batchChangeVisble: boolean = false

  // 批量修改商户产品配置
  private batchMerchantList: any[] = []
  private batchChangelist: any[] = []
  private handleSelectionChange(list) {
    this.batchMerchantList = list
  }

  private openBatch() {
    this.batchChangelist = []
    for (let i = 0; i < this.batchMerchantList.length; i++) {
      this.batchChangelist.push(this.batchMerchantList[i].merchant_no)
    }
    this.batchChangeVisble = true
  }

  private closeBatch() {
    this.batchChangeVisble = false
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.tabName = 'basicInformation'
    this.hadleGetFilesListApi()
  }

  private openDialogVisible(action: string) {
    this.action = action
    this.dialogVisible = true
  }

  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  private async operationCb(info: any) {
    if (info) {
      const data: any = {
        id: this.currentMerchant.merchant_no,
        ...info
      }
      await this.delMerchant(data)
    }
    this.dialogVisible = false
  }

  private openEdit(merchant: any) {
    this.currentMerchant = merchant
    this.drawer = true
  }

  // 删除商户
  private del(obj: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: action => {
        if (action === 'confirm') {
          this.currentMerchant = obj
          isShowDialog('delete_merchant')
            ? this.openDialogVisible('del')
            : this.delMerchant({ id: this.currentMerchant.merchant_no })
        }
      }
    })
  }

  // 跳转商户后台
  private async jump(row: any) {
    const data: any = {
      merchant_no: row.merchant_no
    }
    await jumpMerchantPlatform(data).then((res: any) => {
      window.open(res.url)
    })
  }

  // 跳转商户后台添加google code
  protected jumpForm: any = {
    google_code: ''
  }
  private jumpVisible: boolean = false
  private jumpInfo: any = null
  private async googlreJump(row: any) {
    this.jumpVisible = true
    this.jumpInfo = row
  }
  private closeJump() {
    this.jumpVisible = false
    this.jumpForm = {
      google_code: ''
    }
  }
  private jumpMerchant() {
    ;(this.$refs.jumpForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          const data: any = {
            ...this.jumpForm,
            merchant_no: this.jumpInfo.merchant_no
            // device_fingerprint: this.device_fingerprint.current
          }
          await jumpMerchantPlatform(data).then((res: any) => {
            window.open(res.url)
            this.closeJump()
          })
        } catch (error) {
          this.closeJump()
        }
      } else {
        return false
      }
    })
  }

  private async delMerchant(data: any) {
    await delMerchant(data).then(() => {
      operationMessage(true)
    })
  }

  private async setStatus(obj: any) {
    // 保存原来的状态
    const status = obj.status === 0 ? 1 : 0
    const data: any = {
      merchant_no: obj.merchant_no,
      status: obj.status
    }
    const ops: any = {
      title: 'Task Description',
      key: 'description',
      fn: this.setMerchant,
      params: data,
      authCode: 'change_merchant'
    }
    reqInterceptors(ops)
    obj.status = status
  }

  private async setMerchant(data: any) {
    try {
      await setMerchant(data).then((res: any) => {
        operationMessage(true)
      })
    } catch (e) {}
  }

  private async getMerchantList(isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    const data: any = {
      ...this.form,
      page: this.listQuery.page
    }
    try {
      this.listLoading = true
      await getMerchant(data).then((res: any) => {
        this.total = res.count
        this.merchantList = res.results
        setTimeout(() => {
          this.listLoading = false
        }, 0.5 * 1000)
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    const client = new ClientJS()
    this.device_fingerprint.current = `${client.getFingerprint()}`

    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.merchantMgt`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
